import { render, staticRenderFns } from "./PaytableGame.vue?vue&type=template&id=d3934b12"
import script from "./PaytableGame.vue?vue&type=script&lang=js"
export * from "./PaytableGame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports